export default "__VITE_ASSET__BFjeUY88__"